import { PACKAGE_NAME, PACKAGE_VERSION, getPlatformFeatures } from 'duckdb-wasm-es';
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import { WebLinksAddon } from 'xterm-addon-web-links';
import { WebglAddon } from 'xterm-addon-webgl';

let wasm;

const heap = new Array(32).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

let WASM_VECTOR_LEN = 0;

let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null || cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}

let cachedTextEncoder = new TextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length);
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len);

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3);
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachegetInt32Memory0 = null;
function getInt32Memory0() {
    if (cachegetInt32Memory0 === null || cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
        cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachegetInt32Memory0;
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachegetFloat64Memory0 = null;
function getFloat64Memory0() {
    if (cachegetFloat64Memory0 === null || cachegetFloat64Memory0.buffer !== wasm.memory.buffer) {
        cachegetFloat64Memory0 = new Float64Array(wasm.memory.buffer);
    }
    return cachegetFloat64Memory0;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function makeMutClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            if (--state.cnt === 0) {
                wasm.__wbindgen_export_2.get(state.dtor)(a, state.b);

            } else {
                state.a = a;
            }
        }
    };
    real.original = state;

    return real;
}
function __wbg_adapter_24(arg0, arg1, arg2) {
    var ret = wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__haf28cc4bb77cce74(arg0, arg1, addHeapObject(arg2));
    return ret !== 0;
}

function __wbg_adapter_27(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h75f2cde6a9de4566(arg0, arg1, addHeapObject(arg2));
}

/**
*/
export function main() {
    wasm.main();
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}

let cachegetUint32Memory0 = null;
function getUint32Memory0() {
    if (cachegetUint32Memory0 === null || cachegetUint32Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint32Memory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachegetUint32Memory0;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4);
    getUint32Memory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1);
    getUint8Memory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
* @param {HTMLElement} elem
* @param {any} runtime
* @param {any} options
*/
export function embed(elem, runtime, options) {
    wasm.embed(addHeapObject(elem), addHeapObject(runtime), addHeapObject(options));
}

/**
* @param {string} text
*/
export function write(text) {
    var ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.write(ptr0, len0);
}

/**
* @param {string} text
*/
export function writeln(text) {
    var ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.writeln(ptr0, len0);
}

/**
* @param {string} name
* @param {boolean} enable
*/
export function collectFileStatistics(name, enable) {
    var ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.collectFileStatistics(ptr0, len0, enable);
}

/**
* @param {number} _width
* @param {number} _height
*/
export function resize(_width, _height) {
    wasm.resize(_width, _height);
}

let stack_pointer = 32;

function addBorrowedObject(obj) {
    if (stack_pointer == 1) throw new Error('out of js stack');
    heap[--stack_pointer] = obj;
    return stack_pointer;
}
/**
* @param {Array<any>} history
* @param {number} cursor
*/
export function loadHistory(history, cursor) {
    try {
        wasm.loadHistory(addBorrowedObject(history), cursor);
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
* @param {any} db
* @returns {any}
*/
export function configureDatabase(db) {
    var ret = wasm.configureDatabase(addHeapObject(db));
    return takeObject(ret);
}

/**
* @param {number} ctx
* @returns {any}
*/
export function resumeAfterInput(ctx) {
    var ret = wasm.resumeAfterInput(ctx);
    return takeObject(ret);
}

function __wbg_adapter_211(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen__convert__closures__invoke2_mut__h1355db23c62edde6(arg0, arg1, addHeapObject(arg2), addHeapObject(arg3));
}

/**
*/
export const WcWidth = Object.freeze({ Width0:0,"0":"Width0",Width1:1,"1":"Width1",Width2:2,"2":"Width2", });
/**
* A shell input context
*/
export const ShellInputContext = Object.freeze({ FileInput:0,"0":"FileInput", });
/**
*/
export class DuckDBConfig {

    static __wrap(ptr) {
        const obj = Object.create(DuckDBConfig.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_duckdbconfig_free(ptr);
    }
    /**
    * @returns {string | undefined}
    */
    get path() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.duckdbconfig_path(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v0;
            if (r0 !== 0) {
                v0 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1);
            }
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string | undefined} path
    */
    set path(path) {
        var ptr0 = isLikeNone(path) ? 0 : passStringToWasm0(path, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.duckdbconfig_set_path(this.ptr, ptr0, len0);
    }
}

async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

async function init(input) {
    if (typeof input === 'undefined') {
        input = new URL('shell_bg.wasm', import.meta.url);
    }
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_setallowProposedApi_cfb269e8e3377640 = function(arg0, arg1) {
        getObject(arg0).allowProposedApi = arg1 !== 0;
    };
    imports.wbg.__wbg_setcursorBlink_a86479d2e1c79045 = function(arg0, arg1) {
        getObject(arg0).cursorBlink = arg1 !== 0;
    };
    imports.wbg.__wbg_setcursorWidth_33b9ca879009416e = function(arg0, arg1) {
        getObject(arg0).cursorWidth = arg1 >>> 0;
    };
    imports.wbg.__wbg_setdrawBoldTextInBrightColors_fd29f92ff197d87d = function(arg0, arg1) {
        getObject(arg0).drawBoldTextInBrightColors = arg1 !== 0;
    };
    imports.wbg.__wbg_setfontSize_2390052bdfa0951f = function(arg0, arg1) {
        getObject(arg0).fontSize = arg1 >>> 0;
    };
    imports.wbg.__wbg_setfontFamily_a76723a99b3e1c44 = function(arg0, arg1, arg2) {
        getObject(arg0).fontFamily = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_setrightClickSelectsWord_b360a1259d32073b = function(arg0, arg1) {
        getObject(arg0).rightClickSelectsWord = arg1 !== 0;
    };
    imports.wbg.__wbg_setrows_869f76d0b575783a = function(arg0, arg1) {
        getObject(arg0).rows = arg1 >>> 0;
    };
    imports.wbg.__wbg_settheme_8e79c01462f90cdf = function(arg0, arg1) {
        getObject(arg0).theme = getObject(arg1);
    };
    imports.wbg.__wbg_setforeground_edd982f95949c129 = function(arg0, arg1, arg2) {
        getObject(arg0).foreground = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_setbackground_24012fa04dc675fc = function(arg0, arg1, arg2) {
        getObject(arg0).background = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_setbrightYellow_862f40b15257431a = function(arg0, arg1, arg2) {
        getObject(arg0).brightYellow = getStringFromWasm0(arg1, arg2);
    };
    imports.wbg.__wbg_construct_9d9938ba79ea4475 = function(arg0) {
        var ret = new Terminal(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_cols_f4f2fd6e0933a109 = function(arg0) {
        var ret = getObject(arg0).cols;
        return ret;
    };
    imports.wbg.__wbg_focus_5fff41e8198ad0b4 = function(arg0) {
        getObject(arg0).focus();
    };
    imports.wbg.__wbg_open_c7703947d6302f6c = function(arg0, arg1) {
        getObject(arg0).open(takeObject(arg1));
    };
    imports.wbg.__wbg_attachCustomKeyEventHandler_9c38a062a62eddd5 = function(arg0, arg1) {
        getObject(arg0).attachCustomKeyEventHandler(getObject(arg1));
    };
    imports.wbg.__wbg_write_167ebfb900d36862 = function(arg0, arg1, arg2) {
        getObject(arg0).write(getStringFromWasm0(arg1, arg2));
    };
    imports.wbg.__wbg_loadAddon_0d8374e2ad409924 = function(arg0, arg1) {
        getObject(arg0).loadAddon(takeObject(arg1));
    };
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_instanceof_WebglAddon_c39f68697a31af73 = function(arg0) {
        var ret = getObject(arg0) instanceof WebglAddon;
        return ret;
    };
    imports.wbg.__wbg_instanceof_WebLinksAddon_fbcf4efb54881c53 = function(arg0) {
        var ret = getObject(arg0) instanceof WebLinksAddon;
        return ret;
    };
    imports.wbg.__wbindgen_json_serialize = function(arg0, arg1) {
        const obj = getObject(arg1);
        var ret = JSON.stringify(obj === undefined ? null : obj);
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_new_670d6f7b0bfae3ee = function() {
        var ret = new FitAddon();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_static_accessor_PACKAGE_VERSION_69095c82ffdcb28a = function(arg0) {
        var ret = PACKAGE_VERSION;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_static_accessor_PACKAGE_NAME_1223ce44d2a7c211 = function(arg0) {
        var ret = PACKAGE_NAME;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_fit_fea2302f520fa7cc = function(arg0) {
        getObject(arg0).fit();
    };
    imports.wbg.__wbindgen_cb_drop = function(arg0) {
        const obj = takeObject(arg0).original;
        if (obj.cnt-- == 1) {
            obj.a = 0;
            return true;
        }
        var ret = false;
        return ret;
    };
    imports.wbg.__wbg_log_39e5c6dfbf35ce2a = function(arg0, arg1) {
        console.log(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_error_e42d6a50bd4cd544 = function(arg0, arg1) {
        console.error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_warn_8c6115cb2bc8bed9 = function(arg0, arg1) {
        console.warn(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_bigInt64Array_4c69a4b8851388a0 = function(arg0) {
        var ret = getObject(arg0).bigInt64Array;
        return ret;
    };
    imports.wbg.__wbg_wasmThreads_2354f91bd174123e = function(arg0) {
        var ret = getObject(arg0).wasmThreads;
        return ret;
    };
    imports.wbg.__wbg_wasmExceptions_29becc42f9363495 = function(arg0) {
        var ret = getObject(arg0).wasmExceptions;
        return ret;
    };
    imports.wbg.__wbg_wasmSIMD_b9d56efa1051a529 = function(arg0) {
        var ret = getObject(arg0).wasmSIMD;
        return ret;
    };
    imports.wbg.__wbg_wasmBulkMemory_4498aec02017e31d = function(arg0) {
        var ret = getObject(arg0).wasmBulkMemory;
        return ret;
    };
    imports.wbg.__wbg_crossOriginIsolated_d9f5c0343a3944cf = function(arg0) {
        var ret = getObject(arg0).crossOriginIsolated;
        return ret;
    };
    imports.wbg.__wbg_offsets_b3b1bdd37d9a4f30 = function(arg0, arg1) {
        var ret = getObject(arg1).offsets;
        var ptr0 = passArray32ToWasm0(ret, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_types_cc4d77772fac0646 = function(arg0, arg1) {
        var ret = getObject(arg1).types;
        var ptr0 = passArray8ToWasm0(ret, wasm.__wbindgen_malloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_fontFamily_bf454fed644c371e = function(arg0, arg1) {
        var ret = getObject(arg1).fontFamily;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_backgroundColor_13124d7a2f6922da = function(arg0, arg1) {
        var ret = getObject(arg1).backgroundColor;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_withWebGL_23ecf5d40e6afbed = function(arg0) {
        var ret = getObject(arg0).withWebGL;
        return ret;
    };
    imports.wbg.__wbg_new_58c6288db0a82870 = function(arg0) {
        var ret = new WebglAddon(arg0 === 0xFFFFFF ? undefined : arg0 !== 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_object_clone_ref = function(arg0) {
        var ret = getObject(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_6bf4fb65423e34f9 = function(arg0, arg1, arg2) {
        var ret = new WebLinksAddon(getObject(arg0), getObject(arg1), arg2 === 0xFFFFFF ? undefined : arg2 !== 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_blockStats_37af7282d08c3b7e = function(arg0) {
        var ret = getObject(arg0).blockStats;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_totalFileWrites_34e384ac37ed6460 = function(arg0) {
        var ret = getObject(arg0).totalFileWrites;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_totalFileReadsAhead_e35d465c3fcbceee = function(arg0) {
        var ret = getObject(arg0).totalFileReadsAhead;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_totalFileReadsCold_4c710e3323280cc2 = function(arg0) {
        var ret = getObject(arg0).totalFileReadsCold;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_totalFileReadsCached_8148e83dd67cd58b = function(arg0) {
        var ret = getObject(arg0).totalFileReadsCached;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_totalPageAccesses_fabdf512d40a7df9 = function(arg0) {
        var ret = getObject(arg0).totalPageAccesses;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_totalPageLoads_fcd9696fe68b5d7b = function(arg0) {
        var ret = getObject(arg0).totalPageLoads;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_blockSize_7f5a036ef18b0d64 = function(arg0) {
        var ret = getObject(arg0).blockSize;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_getFeatureFlags_d2521bde579969a1 = function() { return handleError(function (arg0) {
        var ret = getObject(arg0).getFeatureFlags();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_collectFileStatistics_09b010fd31d76a49 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        var ret = getObject(arg0).collectFileStatistics(getStringFromWasm0(arg1, arg2), arg3 !== 0);
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_exportFileStatistics_8f0bf2a4e4374dfc = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).exportFileStatistics(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_pushInputToHistory_be6169df38305347 = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).pushInputToHistory(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_getPlatformFeatures_850d8f62528a5bc5 = function() { return handleError(function () {
        var ret = getPlatformFeatures();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_open_0e5b6f2961a05f4a = function() { return handleError(function (arg0, arg1) {
        var ret = getObject(arg0).open(DuckDBConfig.__wrap(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_getVersion_d62d5530e7e4e4c4 = function() { return handleError(function (arg0) {
        var ret = getObject(arg0).getVersion();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_connectInternal_52ac711d73cb5a62 = function() { return handleError(function (arg0) {
        var ret = getObject(arg0).connectInternal();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_copyFileToBuffer_6d15ceb2c99c40e7 = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).copyFileToBuffer(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_dropFiles_21b3655c7466e25a = function() { return handleError(function (arg0) {
        var ret = getObject(arg0).dropFiles();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_dropFile_660945333a5e7d21 = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).dropFile(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_globFiles_03ac2f87de8cab5b = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).globFiles(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_pickFiles_0773778daac97095 = function() { return handleError(function (arg0) {
        var ret = getObject(arg0).pickFiles();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_downloadFile_223fed31724de5a9 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        var ret = getObject(arg0).downloadFile(getStringFromWasm0(arg1, arg2), takeObject(arg3));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_runQuery_0b650323a464f6d2 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        var ret = getObject(arg0).runQuery(arg1 >>> 0, getStringFromWasm0(arg2, arg3));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_tokenize_2c097933410441ee = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).tokenize(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_readClipboardText_cdb76d02b35ab9d4 = function() { return handleError(function (arg0) {
        var ret = getObject(arg0).readClipboardText();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_disconnect_68f8ef5ad86a7cfa = function() { return handleError(function (arg0, arg1) {
        var ret = getObject(arg0).disconnect(arg1 >>> 0);
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_new_59cb74e423758ede = function() {
        var ret = new Error();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_stack_558ba5917b466edd = function(arg0, arg1) {
        var ret = getObject(arg1).stack;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_error_4bb6c2a97407129a = function(arg0, arg1) {
        try {
            console.error(getStringFromWasm0(arg0, arg1));
        } finally {
            wasm.__wbindgen_free(arg0, arg1);
        }
    };
    imports.wbg.__wbg_instanceof_Window_11e25482011fc506 = function(arg0) {
        var ret = getObject(arg0) instanceof Window;
        return ret;
    };
    imports.wbg.__wbg_performance_9d1ecf711183e1d5 = function(arg0) {
        var ret = getObject(arg0).performance;
        return isLikeNone(ret) ? 0 : addHeapObject(ret);
    };
    imports.wbg.__wbg_now_44a034aa2e1d73dd = function(arg0) {
        var ret = getObject(arg0).now();
        return ret;
    };
    imports.wbg.__wbg_type_55a19f61b3198ce6 = function(arg0, arg1) {
        var ret = getObject(arg1).type;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_ctrlKey_8fa508d0b540bc8f = function(arg0) {
        var ret = getObject(arg0).ctrlKey;
        return ret;
    };
    imports.wbg.__wbg_metaKey_d60075e40f8f06d7 = function(arg0) {
        var ret = getObject(arg0).metaKey;
        return ret;
    };
    imports.wbg.__wbg_key_6827d862c9cc3928 = function(arg0, arg1) {
        var ret = getObject(arg1).key;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_get_b7bbf50adcc94294 = function(arg0, arg1) {
        var ret = getObject(arg0)[arg1 >>> 0];
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_555f836564bf148d = function(arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_call_ba36642bd901572b = function() { return handleError(function (arg0, arg1) {
        var ret = getObject(arg0).call(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_self_bb69a836a72ec6e9 = function() { return handleError(function () {
        var ret = self.self;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_window_3304fc4b414c9693 = function() { return handleError(function () {
        var ret = window.window;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_globalThis_e0d21cabc6630763 = function() { return handleError(function () {
        var ret = globalThis.globalThis;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_global_8463719227271676 = function() { return handleError(function () {
        var ret = global.global;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        var ret = getObject(arg0) === undefined;
        return ret;
    };
    imports.wbg.__wbg_newnoargs_9fdd8f3961dd1bee = function(arg0, arg1) {
        var ret = new Function(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_3e1ee746fe308c9f = function(arg0, arg1) {
        var ret = new Error(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_message_e440fbd911a845a2 = function(arg0) {
        var ret = getObject(arg0).message;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_toString_e5b96b15120ff6d4 = function(arg0) {
        var ret = getObject(arg0).toString();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_call_3fc07b7d5fc9022d = function() { return handleError(function (arg0, arg1, arg2) {
        var ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_new_edbe38a4e21329dd = function() {
        var ret = new Object();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_c143a4f563f78c4e = function(arg0, arg1) {
        try {
            var state0 = {a: arg0, b: arg1};
            var cb0 = (arg0, arg1) => {
                const a = state0.a;
                state0.a = 0;
                try {
                    return __wbg_adapter_211(a, state0.b, arg0, arg1);
                } finally {
                    state0.a = a;
                }
            };
            var ret = new Promise(cb0);
            return addHeapObject(ret);
        } finally {
            state0.a = state0.b = 0;
        }
    };
    imports.wbg.__wbg_resolve_cae3d8f752f5db88 = function(arg0) {
        var ret = Promise.resolve(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_then_c2361a9d5c9a4fcb = function(arg0, arg1) {
        var ret = getObject(arg0).then(getObject(arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_then_6c9a4bf55755f9b8 = function(arg0, arg1, arg2) {
        var ret = getObject(arg0).then(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_buffer_9e184d6f785de5ed = function(arg0) {
        var ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_2d56cb37075fcfb1 = function(arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_new_e8101319e4cf95fc = function(arg0) {
        var ret = new Uint8Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_e8ae7b27314e8b98 = function(arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbindgen_number_get = function(arg0, arg1) {
        const obj = getObject(arg1);
        var ret = typeof(obj) === 'number' ? obj : undefined;
        getFloat64Memory0()[arg0 / 8 + 1] = isLikeNone(ret) ? 0 : ret;
        getInt32Memory0()[arg0 / 4 + 0] = !isLikeNone(ret);
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = getObject(arg1);
        var ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr0 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        var ret = debugString(getObject(arg1));
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_rethrow = function(arg0) {
        throw takeObject(arg0);
    };
    imports.wbg.__wbindgen_memory = function() {
        var ret = wasm.memory;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper466 = function(arg0, arg1, arg2) {
        var ret = makeMutClosure(arg0, arg1, 66, __wbg_adapter_24);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper978 = function(arg0, arg1, arg2) {
        var ret = makeMutClosure(arg0, arg1, 169, __wbg_adapter_27);
        return addHeapObject(ret);
    };

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }



    const { instance, module } = await load(await input, imports);

    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;
    wasm.__wbindgen_start();
    return wasm;
}

export default init;

